import { useRef } from "react";
import { RoomCollection } from "@lifeat/shared/data-models/Rooms/RoomEntity";
import { useDatabaseContext } from "@contexts/DatabaseContext";
import { useAlarmSoundOptions } from "./useAlarmSoundOptions";
import { useServerPomodoro } from "./useServerPomodoro";

export function useHeadlessPomodoroReadonly(roomId: string) {
    const db = useDatabaseContext();
    const pomodoroService = {
        fetchSettings: async () => {
            if (roomId) {
                return (await db.get(RoomCollection.at(roomId).at("groupPomodoro").at("settings").node)) ?? null;
            }
            return null;
        },
    };
    const alarmSoundOptions = useAlarmSoundOptions(pomodoroService);
    const audioRef = useRef(null);
    return useServerPomodoro({
        roomId,
        hidden: true,
        alarmSoundOptions,
        pomodoroService,
        audioRef,
    });
}
